/**
 * The bare DEC lettermark, D E C, no ENERGY wordmark, no contract sheet, in
 * `currentColor` so the caller sets the colour. Glyph outlines are the ones the
 * companies hero contract ships; `DecContract` composes the same paths onto its
 * sheet.
 */
const DEC_S = 455 / 34;
const DEC_D =
  "M12.637 0L0.00532744 0L0.00528992 3L12.637 3C18.137 3 25.637 8.5 25.637 17C25.637 25.5 18.1367 31 12.637 31L0 31L0 34H12.637C15.6367 34 28.6364 31 28.6367 17C28.637 3 15.9507 0 12.637 0Z";
const DEC_C =
  "M15.9997 34H28.6314L28.6314 31H15.9997C10.4997 31 2.99972 25.5 2.99972 17C2.99972 8.5 10.5 3 15.9997 3H28.6367V0H15.9997C13 0 0.000280437 3 0 17C-0.000280437 31 12.686 34 15.9997 34Z";
const DEC_E = [
  "M0.636719 1.5V3H15.1367H29.636719V1.5V0H15.1367H0.636719V1.5Z",
  "M0.636719 17V18.5H15.1367H29.636719V17V15.5H15.1367H0.636719V17Z",
  "M0.636719 32.5V34H15.1367H29.636719V32.5V31H15.1367H0.636719V32.5Z",
];

/**
 * The D E C glyph paths as three positioned groups, no fill or outer transform,
 * so the caller's wrapping `<g>` sets those. Shared by `DecMark` and `DecContract`.
 */
export function DecGlyphs() {
  return (
    <>
      <g transform={`scale(${DEC_S})`}>
        <path d={DEC_D} />
      </g>
      <g transform={`translate(447.7 0) scale(${DEC_S})`}>
        {DEC_E.map((d, i) => (
          <path key={i} d={d} />
        ))}
      </g>
      <g transform={`translate(925.8 0) scale(${DEC_S})`}>
        <path d={DEC_C} />
      </g>
    </>
  );
}

export function DecMark({ className = "" }: { className?: string }) {
  return (
    <svg viewBox="-20 0 1349 455" className={`block ${className}`} aria-hidden="true">
      <g fill="currentColor">
        <DecGlyphs />
      </g>
    </svg>
  );
}
